export const GET_FLIGHT_BY_ID = "exchange/GET_FLIGHT_BY_ID";
export type GET_FLIGHT_BY_ID = typeof GET_FLIGHT_BY_ID;

export const GET_FLIGHT_SUMMARIES = "exchange/GET_FLIGHT_SUMMARIES";
export type GET_FLIGHT_SUMMARIES = typeof GET_FLIGHT_SUMMARIES;
